
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shipping-to-storage",
      function () {
        return require("private-next-pages/shipping-to-storage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shipping-to-storage"])
      });
    }
  